(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tslib"), require("@angular/core"), require("@angular/common/http"), require("@ngforage/ngforage-ng5"), require("rxjs/add/operator/filter"), require("rxjs/add/operator/map"), require("rxjs/add/operator/switchMap"), require("rxjs/add/operator/toPromise"), require("rxjs/BehaviorSubject"), require("rxjs/observable/of"), require("@angular/common"), require("rxjs/add/operator/catch"), require("rxjs/add/operator/debounceTime"), require("rxjs/add/operator/distinctUntilChanged"), require("rxjs/add/operator/share"), require("rxjs/observable/combineLatest"), require("rxjs/observable/fromPromise"));
	else if(typeof define === 'function' && define.amd)
		define(["tslib", "@angular/core", "@angular/common/http", "@ngforage/ngforage-ng5", "rxjs/add/operator/filter", "rxjs/add/operator/map", "rxjs/add/operator/switchMap", "rxjs/add/operator/toPromise", "rxjs/BehaviorSubject", "rxjs/observable/of", "@angular/common", "rxjs/add/operator/catch", "rxjs/add/operator/debounceTime", "rxjs/add/operator/distinctUntilChanged", "rxjs/add/operator/share", "rxjs/observable/combineLatest", "rxjs/observable/fromPromise"], factory);
	else if(typeof exports === 'object')
		exports["ghContribCalendar"] = factory(require("tslib"), require("@angular/core"), require("@angular/common/http"), require("@ngforage/ngforage-ng5"), require("rxjs/add/operator/filter"), require("rxjs/add/operator/map"), require("rxjs/add/operator/switchMap"), require("rxjs/add/operator/toPromise"), require("rxjs/BehaviorSubject"), require("rxjs/observable/of"), require("@angular/common"), require("rxjs/add/operator/catch"), require("rxjs/add/operator/debounceTime"), require("rxjs/add/operator/distinctUntilChanged"), require("rxjs/add/operator/share"), require("rxjs/observable/combineLatest"), require("rxjs/observable/fromPromise"));
	else
		root["ghContribCalendar"] = factory(root["tslib"], root["ng"]["core"], root["ng"]["commonHttp"], root["@ngforage/ngforage-ng5"], root["Rx"], root["Rx"], root["Rx"], root["Rx"], root["Rx"], root["Rx"]["Observable"], root["ng"]["common"], root["Rx"], root["Rx"], root["Rx"], root["Rx"], root["Rx"]["Observable"], root["Rx"]["Observable"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_24__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Translator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTranslations_en__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultTranslations_lt__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultTranslations_ru__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__ = __webpack_require__(4);






/** @internal */
function calculateOrder(input) {
    switch (input) {
        case 5 /* DATE_TEXT_COUNT */:
            return [__WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].DATE, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].TEXT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].COUNT];
        case 1 /* COUNT_DATE_TEXT */:
            return [__WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].COUNT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].DATE, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].TEXT];
        case 2 /* TEXT_COUNT_DATE */:
            return [__WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].TEXT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].COUNT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].DATE];
        case 3 /* TEXT_DATE_COUNT */:
            return [__WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].TEXT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].DATE, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].COUNT];
        case 4 /* DATE_COUNT_TEXT */:
            return [__WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].DATE, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].COUNT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].TEXT];
        default:
            return [__WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].COUNT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].TEXT, __WEBPACK_IMPORTED_MODULE_5__types_ContributionCountElement__["a" /* ContributionCountElement */].DATE];
    }
}
/** A basic UI translator */
var Translator = (function () {
    function Translator() {
        this.registerTranslations(__WEBPACK_IMPORTED_MODULE_2__defaultTranslations_en__["a" /* englishTranslations */]);
    }
    Object.defineProperty(Translator.prototype, "hideZero", {
        /** Whether or not the number 0 should be hidden if there are no contributions on the given day */
        get: function () {
            return this.result.hideZero;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register custom translations
     * @param tr The translations
     */
    Translator.prototype.registerTranslations = function (tr) {
        if (tr !== this.previousRegistration) {
            this.previousRegistration = tr;
            this.result = Object.assign({}, __WEBPACK_IMPORTED_MODULE_2__defaultTranslations_en__["a" /* englishTranslations */], tr || {});
            this.order = calculateOrder(this.result.order);
            Object.freeze(this.order);
        }
    };
    /**
     * Set a predefined locale
     * @param locale The locale
     * @throws {Error} If the locale is unknown
     */
    Translator.prototype.setLocale = function (locale) {
        switch (locale) {
            case 'en':
                this.registerTranslations(__WEBPACK_IMPORTED_MODULE_2__defaultTranslations_en__["a" /* englishTranslations */]);
                break;
            case 'ru':
                this.registerTranslations(__WEBPACK_IMPORTED_MODULE_4__defaultTranslations_ru__["a" /* russianTranslations */]);
                break;
            case 'lt':
                this.registerTranslations(__WEBPACK_IMPORTED_MODULE_3__defaultTranslations_lt__["a" /* ltTranslations */]);
                break;
            default:
                throw new Error("Unknown locale: " + locale);
        }
    };
    /**
     * Translate a string
     * @param key The code/id to translate
     * @param qty If the translation is countable, the quantity
     * @returns The translated string
     * @throws {Error} If the key is unknown
     */
    Translator.prototype.translate = function (key, qty) {
        var tr = this.result[key];
        if (!tr) {
            throw new Error("Unknown translation key: " + key);
        }
        if (typeof tr === 'string') {
            return tr;
        }
        else if (tr[qty]) {
            return tr[qty];
        }
        else if (tr.other) {
            return tr.other;
        }
        throw new Error("Unable to find translation for key " + key + " qty " + qty);
    };
    Translator = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [])
    ], Translator);
    return Translator;
}());



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepFreeze;
/** @internal */
function deepFreeze(obj) {
    for (var _i = 0, _a = Object.getOwnPropertyNames(obj); _i < _a.length; _i++) {
        var name_1 = _a[_i];
        var prop = obj[name_1];
        if (typeof prop === 'object' && prop !== null) {
            deepFreeze(prop);
        }
    }
    Object.freeze(obj);
    return obj;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContributionCountElement; });
/** Marks a contribution text element - the localised string, the contributions count or the date */
var ContributionCountElement;
(function (ContributionCountElement) {
    /** The localised string */
    ContributionCountElement[ContributionCountElement["TEXT"] = 0] = "TEXT";
    /** The contributions count */
    ContributionCountElement[ContributionCountElement["COUNT"] = 1] = "COUNT";
    /** The date */
    ContributionCountElement[ContributionCountElement["DATE"] = 2] = "DATE";
})(ContributionCountElement || (ContributionCountElement = {}));
Object.freeze(ContributionCountElement);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultFormatterFunction;
/** @internal */
function defaultFormatterFunction(username, toYear, toMonth, toDay) {
    var url = "https://gh-contrib-parser-public.herokuapp.com/fetch" /* DEFAULT_PUBLIC_HOST */ + "/" + username;
    if (toYear && toMonth && toDay) {
        url += "?to=" + toYear + "-" + toMonth + "-" + toDay;
    }
    return url;
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GhContribCalendar_GhContribCalendarModule__ = __webpack_require__(15);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "GhContribCalendarModule", function() { return __WEBPACK_IMPORTED_MODULE_0__GhContribCalendar_GhContribCalendarModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GhContribCalendar_Translate_Translator__ = __webpack_require__(2);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Translator", function() { return __WEBPACK_IMPORTED_MODULE_1__GhContribCalendar_Translate_Translator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GhContribCalendar_Translate_index__ = __webpack_require__(39);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_2__GhContribCalendar_Translate_index__) if(["GhContribCalendarModule","Translator","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_2__GhContribCalendar_Translate_index__[key]; }) }(__WEBPACK_IMPORT_KEY__));





/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GhContribCalendarModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common_http__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__angular_common_http__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ngforage_ngforage_ng5__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ngforage_ngforage_ng5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ngforage_ngforage_ng5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CalendarComponent_GhContribCalendarComponent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CalendarFetcher_defaultFormatterFunction__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Chevron_Chevron__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DayDetails_DayDetails__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LoadingBar_LoadingBar__ = __webpack_require__(36);










/** The main module */
var GhContribCalendarModule = (function () {
    function GhContribCalendarModule() {
    }
    GhContribCalendarModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_3__angular_core__["NgModule"])({
            declarations: [
                __WEBPACK_IMPORTED_MODULE_5__CalendarComponent_GhContribCalendarComponent__["a" /* GhContribCalendarComponent */],
                __WEBPACK_IMPORTED_MODULE_7__Chevron_Chevron__["a" /* Chevron */],
                __WEBPACK_IMPORTED_MODULE_8__DayDetails_DayDetails__["a" /* DayDetails */],
                __WEBPACK_IMPORTED_MODULE_9__LoadingBar_LoadingBar__["a" /* LoadingBar */]
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_5__CalendarComponent_GhContribCalendarComponent__["a" /* GhContribCalendarComponent */]
            ],
            imports: [
                __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_2__angular_common_http__["HttpClientModule"],
                __WEBPACK_IMPORTED_MODULE_4__ngforage_ngforage_ng5__["NgForageModule"]
            ],
            providers: [
                {
                    provide: __WEBPACK_IMPORTED_MODULE_6__CalendarFetcher_defaultFormatterFunction__["a" /* defaultFormatterFunction */],
                    useValue: __WEBPACK_IMPORTED_MODULE_6__CalendarFetcher_defaultFormatterFunction__["a" /* defaultFormatterFunction */]
                }
            ]
        })
    ], GhContribCalendarModule);
    return GhContribCalendarModule;
}());



/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GhContribCalendarComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_catch__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_debounceTime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_debounceTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_distinctUntilChanged__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_distinctUntilChanged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_share__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_switchMap__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_toPromise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_combineLatest__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_observable_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CalendarFetcher_CalendarFetcher__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Translate_Translator__ = __webpack_require__(2);















/** @internal */
var currDate = new Date();
currDate.setUTCHours(0, 0, 0, 0);
/** The main calendar component */
var GhContribCalendarComponent = (function () {
    function GhContribCalendarComponent(cdr, fetcher, tr) {
        /** @internal */
        this._numLoading = 0;
        /** Any errors that occurred */
        this.error = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        /** Whether or not the controls for changing the year should be shown */
        this.showControls = true;
        /** @internal */
        this.user$ = new __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        /** @internal */
        this.d$ = new __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__["BehaviorSubject"](currDate.getUTCDate());
        /** @internal */
        this.formatterFn$ = new __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__["BehaviorSubject"](null);
        /** @internal */
        this.m$ = new __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__["BehaviorSubject"]((currDate.getUTCMonth() + 1));
        /** @internal */
        this.y$ = new __WEBPACK_IMPORTED_MODULE_10_rxjs_BehaviorSubject__["BehaviorSubject"](currDate.getUTCFullYear());
        this.tr = tr;
        this.fetcher = fetcher;
        this.cdr = cdr;
    }
    Object.defineProperty(GhContribCalendarComponent.prototype, "atMaxRange", {
        /** Whether or not the entered date is today */
        get: function () {
            return currDate.getTime() === this.toDate.getTime();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "day", {
        /** The entered day getter */
        get: function () {
            return this.d$.value;
        },
        /** The entered day setter */
        set: function (v) {
            this.d$.next(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "formatterFn", {
        /** Proxy formatter function getter */
        get: function () {
            return this.formatterFn$.value;
        },
        /** Proxy formatter function setter */
        set: function (fn) {
            if (!fn || typeof fn === 'function') {
                this.formatterFn$.next(fn);
            }
            else {
                throw new Error('formatter-fn must be falsy or a function');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "locale", {
        /** Locale setter */
        set: function (val) {
            this.tr.setLocale(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "month", {
        /** Entered month getter */
        get: function () {
            return this.m$.value;
        },
        /** Entered month setter */
        set: function (v) {
            this.m$.next(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "to", {
        /** Entered date setter */
        set: function (v) {
            if (typeof v === 'string' && /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/.test(v)) {
                var spl = v.split('-');
                this.year = spl[0];
                this.month = spl[1]; // tslint:disable-line:no-magic-numbers
                this.day = spl[2]; // tslint:disable-line:no-magic-numbers
            }
            else if (v instanceof Date) {
                this.year = v.getUTCFullYear();
                this.month = (v.getUTCMonth() + 1);
                this.day = v.getUTCDate();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "translations", {
        /** Custom translations setter */
        set: function (val) {
            this.tr.registerTranslations(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "user", {
        /** Entered user getter */
        get: function () {
            return this.user$.value;
        },
        /** Entered user setter */
        set: function (user) {
            if (this.user && user !== this.user) {
                this.to = currDate;
            }
            this.user$.next(user);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "year", {
        /** Entered year getter */
        get: function () {
            return this.y$.value;
        },
        /** Entered year setter */
        set: function (v) {
            this.y$.next(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "numLoading", {
        /** @internal */
        get: function () {
            return this._numLoading;
        },
        /** @internal */
        set: function (num) {
            this._numLoading = num;
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "toDate", {
        /** @internal */
        get: function () {
            var d = new Date();
            d.setUTCHours(0, 0, 0, 0);
            d.setUTCFullYear(parseInt(this.year, 10 /* STD_RADIX */), parseInt(this.month, 10 /* STD_RADIX */) - 1, parseInt(this.day, 10 /* STD_RADIX */));
            return d;
        },
        enumerable: true,
        configurable: true
    });
    GhContribCalendarComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = [this.user$, this.y$, this.m$, this.d$, this.formatterFn$]; _i < _a.length; _i++) {
            var s = _a[_i];
            s.complete();
            s.unsubscribe();
        }
    };
    /** @internal */
    GhContribCalendarComponent.prototype.ngOnInit = function () {
        this.setupData();
    };
    /** @internal */
    GhContribCalendarComponent.prototype.transformAtIndex = function (index) {
        return "translate(" + index * 13 /* OUTER_G_TRANSFORM_MULTIPLIER */ + ",0)";
    };
    /** @internal */
    GhContribCalendarComponent.prototype.updateRange = function (dir) {
        if (dir === -1) {
            this.y$.next(parseInt(this.year, 10 /* STD_RADIX */) - 1);
        }
        else {
            var td = this.toDate;
            td.setUTCFullYear(td.getUTCFullYear() + 1);
            this.to = td > currDate ? currDate : td;
        }
    };
    GhContribCalendarComponent.prototype.setupData = function () {
        var _this = this;
        var decrease = function () {
            _this.numLoading--;
        };
        var data = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_combineLatest__["combineLatest"])(this.user$.distinctUntilChanged(), this.y$.distinctUntilChanged(), this.m$.map(formatAndPad).distinctUntilChanged(), this.d$.map(formatAndPad).distinctUntilChanged(), this.formatterFn$)
            .filter(function (v) { return !!v[0]; })
            .debounceTime(250 /* FETCH_DEBOUNCE_TIME */)
            .switchMap(function (v) {
            _this.numLoading++;
            // tslint:disable-next-line:no-magic-numbers
            var r = _this.fetcher.fetch(v[0], v[1], v[2], v[3], v[4]).share();
            r.toPromise().then(decrease).catch(decrease);
            return r;
        })
            .catch(function (e) {
            _this.error.emit(e);
            _this.user$.next(null);
            setTimeout(function () {
                _this.setupData();
            }, 0);
            return Object(__WEBPACK_IMPORTED_MODULE_12_rxjs_observable_of__["of"])(null);
        });
        this.data = data.filter(function (v) { return !!v; }).share();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"])('error'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object)
    ], GhContribCalendarComponent.prototype, "error", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('show-controls'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object)
    ], GhContribCalendarComponent.prototype, "showControls", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('d'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "day", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('formatter-fn'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Function])
    ], GhContribCalendarComponent.prototype, "formatterFn", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('locale'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", String),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [String])
    ], GhContribCalendarComponent.prototype, "locale", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('m'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "month", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('to'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "to", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('translations'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "translations", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('user'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", String),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [String])
    ], GhContribCalendarComponent.prototype, "user", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('y'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Object),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "year", null);
    GhContribCalendarComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            changeDetection: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectionStrategy"].OnPush,
            providers: [__WEBPACK_IMPORTED_MODULE_14__Translate_Translator__["a" /* Translator */], __WEBPACK_IMPORTED_MODULE_13__CalendarFetcher_CalendarFetcher__["a" /* CalendarFetcher */]],
            selector: 'gh-contrib-calendar',
            styles: [__webpack_require__(28)],
            template: __webpack_require__(29)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__param"](0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__param"](1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_13__CalendarFetcher_CalendarFetcher__["a" /* CalendarFetcher */])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__param"](2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_14__Translate_Translator__["a" /* Translator */])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [Object, __WEBPACK_IMPORTED_MODULE_13__CalendarFetcher_CalendarFetcher__["a" /* CalendarFetcher */],
            __WEBPACK_IMPORTED_MODULE_14__Translate_Translator__["a" /* Translator */]])
    ], GhContribCalendarComponent);
    return GhContribCalendarComponent;
}());

/** @internal */
function formatAndPad(v) {
    var stringified = v.toString();
    return stringified.length === 1 ? '0' + stringified : stringified;
}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarFetcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common_http__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_common_http__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngforage_ngforage_ng5__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngforage_ngforage_ng5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ngforage_ngforage_ng5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_filter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_toPromise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_BehaviorSubject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_observable_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__defaultFormatterFunction__ = __webpack_require__(13);

//tslint:disable:unified-signatures











/** @internal */
function makeCacheKey(user, y, m, d) {
    return JSON.stringify({
        d: d,
        m: m,
        user: user,
        y: y ? parseInt(y, 10 /* STD_RADIX */) : undefined
    });
}
/** @internal */
function intifyStr(str) {
    return parseInt(str, 10 /* STD_RADIX */);
}
/** @internal */
function formatRect(rect) {
    var split = rect.date.split('-').map(intifyStr);
    var date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    // tslint:disable-next-line:no-magic-numbers
    date.setUTCFullYear(split[0], split[1] - 1, split[2]);
    return {
        count: rect.count,
        date: date,
        fill: rect.fill
    };
}
/** @internal */
function formatRects(rects) {
    return rects.map(formatRect);
}
/** @internal */
function formatPayload(input) {
    return {
        gs: input.gs.map(formatRects),
        months: input.months
    };
}
/** Fetches and formats the calendar via a CORS proxy */
var CalendarFetcher = (function () {
    function CalendarFetcher(cache, fn, http) {
        this.cache = cache;
        this.fn = fn;
        this.http = http;
        cache.cacheTime = 3600000 /* CACHE_TIME */;
        cache.name = "gh_contrib_calendar" /* STORE_NAME */;
        cache.storeName = "gh_contrib_calendar" /* STORE_NAME */;
        cache.description = "GhContribCalendar store" /* STORE_DESCRIPTION */;
    }
    /** @internal */
    CalendarFetcher.prototype.fetch = function (user, fnOrYear, month, day, possibleFn) {
        var _this = this;
        var fnOrYearIsFunction = typeof fnOrYear === 'function';
        var actualFn = fnOrYearIsFunction ?
            fnOrYear :
            possibleFn || this.fn;
        var actualYear = fnOrYearIsFunction ? undefined : fnOrYear;
        var cacheKey = makeCacheKey(user, actualYear, month, day);
        return Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__["fromPromise"])(this.cache.getCached(cacheKey))
            .switchMap(function (cached) {
            if (cached.hasData && (!cached.expired || navigator.onLine === false)) {
                return Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_of__["of"])(formatPayload(cached.data));
            }
            var url = actualFn(user, actualYear, month, day);
            var subj = new __WEBPACK_IMPORTED_MODULE_8_rxjs_BehaviorSubject__["BehaviorSubject"](cached.hasData ? cached.data : null);
            setTimeout(function () {
                _this.http.get(url, {
                    observe: 'body',
                    reportProgress: false,
                    responseType: 'json',
                    withCredentials: false
                })
                    .switchMap(function (v) { return _this.cache.setCached(cacheKey, v); })
                    .toPromise()
                    .then(function (v) {
                    subj.next(v);
                    subj.complete();
                })
                    .catch(function (e) {
                    subj.error(e);
                    subj.complete();
                });
            }, 0);
            return subj.filter(function (v) { return !!v; }).map(formatPayload);
        });
    };
    CalendarFetcher = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__param"](0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__ngforage_ngforage_ng5__["NgForageCache"])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__param"](1, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_11__defaultFormatterFunction__["a" /* defaultFormatterFunction */])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__param"](2, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_common_http__["HttpClient"])),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__ngforage_ngforage_ng5__["NgForageCache"], Function, __WEBPACK_IMPORTED_MODULE_1__angular_common_http__["HttpClient"]])
    ], CalendarFetcher);
    return CalendarFetcher;
}());



/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return englishTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_deepFreeze__ = __webpack_require__(3);

/** English translations */
var englishTranslations = {
    Apr: 'Apr',
    Aug: 'Aug',
    contributions: {
        0: 'No contributions on',
        1: 'contribution on',
        other: 'contributions on'
    },
    Dec: 'Dec',
    Feb: 'Feb',
    Friday: 'Fri',
    hideZero: true,
    Jan: 'Jan',
    Jul: 'Jul',
    Jun: 'Jun',
    Mar: 'Mar',
    May: 'May',
    Monday: 'Mon',
    Nov: 'Nov',
    Oct: 'Oct',
    order: 0 /* COUNT_TEXT_DATE */,
    Sep: 'Sep',
    Wednesday: 'Wed'
};
Object(__WEBPACK_IMPORTED_MODULE_0__util_deepFreeze__["a" /* deepFreeze */])(englishTranslations);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ltTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_deepFreeze__ = __webpack_require__(3);

/** Lithuanian translations translations */
var ltTranslations = {
    Apr: 'Bal',
    Aug: 'Rug',
    contributions: {
        0: 'kontribucijų nebuvo',
        other: 'kontribucijų:'
    },
    Dec: 'Gru',
    Feb: 'Vas',
    Friday: 'Pen',
    hideZero: true,
    Jan: 'Sau',
    Jul: 'Lie',
    Jun: 'Bir',
    Mar: 'Kov',
    May: 'Geg',
    Monday: 'Pir',
    Nov: 'Lap',
    Oct: 'Spa',
    order: 5 /* DATE_TEXT_COUNT */,
    Sep: 'Rug',
    Wednesday: 'Tre'
};
Object(__WEBPACK_IMPORTED_MODULE_0__util_deepFreeze__["a" /* deepFreeze */])(ltTranslations);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return russianTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_deepFreeze__ = __webpack_require__(3);

/** Russian translations */
var russianTranslations = {
    Apr: 'Апр',
    Aug: 'Авг',
    contributions: {
        0: 'контрибуций небыло',
        other: 'контрибуций:'
    },
    Dec: 'Дек',
    Feb: 'Фев',
    Friday: 'Пят',
    hideZero: true,
    Jan: 'Янв',
    Jul: 'Июн',
    Jun: 'Июл',
    Mar: 'Мар',
    May: 'Май',
    Monday: 'Пон',
    Nov: 'Ноя',
    Oct: 'Окт',
    order: 5 /* DATE_TEXT_COUNT */,
    Sep: 'Сеп',
    Wednesday: 'Сре'
};
Object(__WEBPACK_IMPORTED_MODULE_0__util_deepFreeze__["a" /* deepFreeze */])(russianTranslations);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = ":host{border-width:1px;border-style:solid;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;max-width:712px;line-height:21px;display:block;text-align:center;padding:8px;font-size:1em;-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;-ms-text-size-adjust:100%;text-size-adjust:100%;font-family:-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"}.gh-calendar-container{overflow-x:auto;height:118px}.gh-footer{height:21px}.gh-calendar{width:676px;height:104px}.gh-calendar-month{font-size:10px}.gh-calendar-wday{font-size:9px}.gh-calendar-day{width:10px;height:10px}.flex{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.flex.col{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.flex.row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex.sp-bw{-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}\n"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flex col\"><gh-loading-bar [style.visibility]=\"_numLoading &gt; 0 ? &quot;visible&quot; : &quot;hidden&quot;\"></gh-loading-bar><ng-container *ngIf=\"data|async as data\"><div class=\"gh-calendar-container\"><svg class=\"gh-calendar\"><g transform=\"translate(16,20)\"><g [attr.transform]=\"transformAtIndex(gi)\" *ngFor=\"let g of data.gs; index as gi\"><rect class=\"gh-calendar-day\" *ngFor=\"let rect of g; index as ri\" [attr.x]=\"13 - gi\" [attr.y]=\"12 * ri\" [ngClass]=\"'l-' + rect.fill\" (mouseenter)=\"_enteredRect=rect\" (mouseleave)=\"_enteredRect=null\"></rect></g><text class=\"gh-calendar-month\" y=\"-10\" [attr.x]=\"mth.x\" *ngFor=\"let mth of data.months\">{{tr.translate(mth.txt)}}</text><text class=\"gh-calendar-wday\" text-anchor=\"start\" dx=\"-14\" dy=\"20\">{{tr.translate('Monday')}}</text><text class=\"gh-calendar-wday\" text-anchor=\"start\" dx=\"-14\" dy=\"44\">{{tr.translate('Wednesday')}}</text><text class=\"gh-calendar-wday\" text-anchor=\"start\" dx=\"-14\" dy=\"69\">{{tr.translate('Friday')}}</text></g></svg></div><div class=\"gh-footer flex row sp-bw\"><div><button *ngIf=\"showControls\" chevron-btn chevron=\"left\" (click)=\"updateRange(-1)\"></button></div><gh-contrib-calendar-details *ngIf=\"_enteredRect\" [tr]=\"tr\" [date]=\"_enteredRect.date\" [count]=\"_enteredRect.count\"></gh-contrib-calendar-details><div><button *ngIf=\"showControls\" chevron-btn chevron=\"right\" (click)=\"updateRange(1)\" [disabled]=\"atMaxRange\"></button></div></div></ng-container></div>"

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Chevron; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);


/** A basic chevron icon */
var Chevron = (function () {
    function Chevron() {
        /** Chevron direction - "left" or "right" */
        this.dir = 'right';
    }
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('chevron'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", String)
    ], Chevron.prototype, "dir", void 0);
    Chevron = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            changeDetection: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectionStrategy"].OnPush,
            selector: 'button[chevron-btn]',
            styles: [__webpack_require__(31)],
            // tslint:disable-next-line:max-line-length
            template: '<svg [ngClass]="dir" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 438.533 438.533"><path d="M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064zm-74.801 122.908L204.71 361.736c-3.617 3.613-7.896 5.428-12.847 5.428-4.952 0-9.235-1.814-12.85-5.428l-29.121-29.13c-3.617-3.613-5.426-7.898-5.426-12.847 0-4.941 1.809-9.232 5.426-12.847l87.653-87.646-87.657-87.65c-3.617-3.612-5.426-7.898-5.426-12.845 0-4.949 1.809-9.231 5.426-12.847l29.121-29.13c3.619-3.615 7.898-5.424 12.85-5.424 4.95 0 9.233 1.809 12.85 5.424l129.622 129.621c3.613 3.614 5.42 7.898 5.42 12.847.001 4.951-1.806 9.236-5.419 12.849z"/></svg>'
        })
    ], Chevron);
    return Chevron;
}());



/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = ":host{border:none;color:inherit;padding:0;background:transparent;cursor:pointer}:host[disabled]{opacity:.5 !important;cursor:default}svg{height:21px;width:21px;fill:currentColor}.left{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}\n"

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_typescript_proto_decorator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translate_Translator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Translate_types_ContributionCountElement__ = __webpack_require__(4);





/** Details about the hovered day */
var DayDetails = (function () {
    function DayDetails() {
    }
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_2_typescript_proto_decorator__["a" /* Proto */])(__WEBPACK_IMPORTED_MODULE_4__Translate_types_ContributionCountElement__["a" /* ContributionCountElement */]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Number)
    ], DayDetails.prototype, "ccEl", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('count'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Number)
    ], DayDetails.prototype, "count", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('date'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", Date)
    ], DayDetails.prototype, "date", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('tr'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"]("design:type", __WEBPACK_IMPORTED_MODULE_3__Translate_Translator__["a" /* Translator */])
    ], DayDetails.prototype, "tr", void 0);
    DayDetails = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            changeDetection: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectionStrategy"].OnPush,
            selector: 'gh-contrib-calendar-details',
            styles: [__webpack_require__(34)],
            template: __webpack_require__(35)
        })
    ], DayDetails);
    return DayDetails;
}());



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Proto;
/**
 * Sets a value on the class' prototype
 * @param value The value to set
 * @param configurable Whether the value should be configurable
 * @param enumerable Whether the value should be enumerable
 * @return {(target: any, prop: string) => void}
 */
function Proto(value, configurable, enumerable) {
    if (configurable === void 0) { configurable = true; }
    if (enumerable === void 0) { enumerable = true; }
    return function (target, propertyKey) {
        Object.defineProperty(target.constructor.prototype, propertyKey, {
            configurable: configurable,
            enumerable: enumerable,
            value: value
        });
    };
}
//# sourceMappingURL=ProtoDecorator.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "span:not(:last-child)::after,time:not(:last-child)::after{content:' '}.count,time{font-weight:bold}\n"

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = "<ng-container *ngFor=\"let item of tr.order\"><span *ngIf=\"item === ccEl.TEXT; else timeBlock\">{{tr.translate('contributions', count)}}</span><ng-template #timeBlock><time *ngIf=\"item === ccEl.DATE; else countBlock\" [attr.datetime]=\"date.toISOString()\">{{date.toLocaleDateString()}}</time><ng-template #countBlock><span class=\"count\" *ngIf=\"count !== 0 || !tr.hideZero\">{{count.toLocaleString()}}</span></ng-template></ng-template></ng-container>"

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tslib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);


/** An animated loading bar */
var LoadingBar = (function () {
    function LoadingBar() {
    }
    LoadingBar = __WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"]([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            changeDetection: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectionStrategy"].OnPush,
            selector: 'gh-loading-bar',
            styles: [__webpack_require__(37)],
            template: __webpack_require__(38)
        })
    ], LoadingBar);
    return LoadingBar;
}());



/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = "/*! https://codepen.io/brunjo/pen/xbwVXJ */:host{position:relative;width:100%;height:6px;background-color:#fdba2c;display:block}.gh-bar-inner{content:\" \";display:inline;position:absolute;width:0;height:100%;left:50%;text-align:center}.gh-bar-inner:nth-child(1){background-color:#da4733;-webkit-animation:gh-calendar-loading 2s linear infinite;-moz-animation:gh-calendar-loading 2s linear infinite;-o-animation:gh-calendar-loading 2s linear infinite;animation:gh-calendar-loading 2s linear infinite}.gh-bar-inner:nth-child(2){background-color:#3b78e7;-webkit-animation:gh-calendar-loading 2s linear .6666s infinite;-moz-animation:gh-calendar-loading 2s linear .6666s infinite;-o-animation:gh-calendar-loading 2s linear .6666s infinite;animation:gh-calendar-loading 2s linear .6666s infinite}.gh-bar-inner:nth-child(3){background-color:#fdba2c;-webkit-animation:gh-calendar-loading 2s linear 1.2222s infinite;-moz-animation:gh-calendar-loading 2s linear 1.2222s infinite;-o-animation:gh-calendar-loading 2s linear 1.2222s infinite;animation:gh-calendar-loading 2s linear 1.2222s infinite}@-webkit-keyframes gh-calendar-loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}@-moz-keyframes gh-calendar-loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}@-o-keyframes gh-calendar-loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}@keyframes gh-calendar-loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}\n"

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gh-bar-inner\"></div><div class=\"gh-bar-inner\"></div><div class=\"gh-bar-inner\"></div>"

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Translator__ = __webpack_require__(2);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Translator", function() { return __WEBPACK_IMPORTED_MODULE_0__Translator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_ContributionCountElement__ = __webpack_require__(4);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ContributionCountElement", function() { return __WEBPACK_IMPORTED_MODULE_1__types_ContributionCountElement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_ContributionCountOrder__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_ContributionCountOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__types_ContributionCountOrder__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_2__types_ContributionCountOrder__) if(["Translator","ContributionCountElement","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_2__types_ContributionCountOrder__[key]; }) }(__WEBPACK_IMPORT_KEY__));





/***/ }),
/* 40 */
/***/ (function(module, exports) {



/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.min.js